import { Text } from '#atoms';
import { HighlightCard } from 'src/components/templates/HighlightCardTemplate';
import {
  ChartTab,
  ComparisonBox,
  ItemBox,
  ImgBox,
  Tab,
  TextBox,
  HistoryBox
} from './styles';
import { useState } from 'react';
import TrainerImg from '#assets/img/trainerImg.png';
export const BodyShape = () => {
  const [selectedTab, setSelectedTab] = useState('전후비교');
  const tabList = ['전후비교', '히스토리'];
  return (
    <HighlightCard>
      <TextBox>
        <Text
          style={{
            color: 'var(--color-gray-text2)',
            fontSize: '1.4rem',
            lineHeight: '2rem'
          }}
        >
          눈바디 변화
        </Text>
        <Text
          textStyle="bb"
          style={{
            fontSize: '2rem',
            color: '#EAE8ED',
            lineHeight: '2.6rem',
            textAlign: 'center',
            fontWeight: 700
          }}
        >
          체형은 이렇게
          <br />
          변화했어요!
        </Text>
      </TextBox>
      {selectedTab === '전후비교' ? (
        <ComparisonBox>
          <ImgBox>
            <img src={dummyData.imageHistory[0].resizedLink} />
            <p className="Before">전</p>
          </ImgBox>
          <ImgBox>
            <img
              src={
                dummyData.imageHistory[dummyData.imageHistory.length - 1]
                  .resizedLink
              }
            />
            <p className="After">후</p>
          </ImgBox>
        </ComparisonBox>
      ) : (
        <HistoryBox>
          {dummyData.imageHistory.map((img, index) => (
            <ItemBox key={index}>
              <img src={img.resizedLink} />
              <p>{dummyData.xLabels[index]}</p>
            </ItemBox>
          ))}
        </HistoryBox>
      )}
      <ChartTab>
        {tabList.map(tab => (
          <Tab
            isSelected={tab === selectedTab}
            onClick={() => setSelectedTab(tab)}
          >
            {tab}
          </Tab>
        ))}
      </ChartTab>
    </HighlightCard>
  );
};
const dummyData = {
  data: [50, 80, 60, 90, 70, 85, 100],
  imageHistory: [
    { resizedLink: TrainerImg },
    { resizedLink: TrainerImg },
    { resizedLink: TrainerImg },
    { resizedLink: TrainerImg },
    { resizedLink: TrainerImg },
    { resizedLink: TrainerImg },
    { resizedLink: TrainerImg }
  ], //IFileResponse 타입
  xLabels: ['월', '화', '수', '목', '금', '토', '일'],
  circleColor: '#FF5733' // 선택된 점의 색상
  // legend: '주간 데이터' // 범례
  // hasYLables: true // Y축 라벨 표시 여부
};
